// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext, useMemo, Fragment} from 'react';
import cn from 'classnames';
import {Editor} from '../../../../../shared/editor/editor';
import {Button} from '../../../lib/button';
import {Lottie} from '../../../lib/lottie';
import {use_browser} from '../../../lib/use_browser';
import {Settings_context} from '../../../settings_ctx';
import {img_url} from '../../../ui/img_url';
import {open_store} from '../../../ui/install_btn';
import styles from './product_hero.module.less';
import {App_context} from 'hola_app_context';
import {use_element_size, use_screen} from '../../../lib/screen_util';
import {Svg_img} from '../../../ui/svg_img';

interface i_product_hero {
    title?: string;
    description?: string;
    lottie_src?: string;
    type: string;
    with_options: boolean;
}

interface i_product_hero_props_editor {
    value: i_product_hero;
    on_change: (new_value: i_product_hero)=>void;
}

export const Product_hero = (props: i_product_hero)=>{
    const {title: hero_title, description, lottie_src,
      with_options} = props;
    const {theme} = useContext(Settings_context);
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const {screen} = use_screen();
    const br = use_browser(['chrome', 'opera', 'edge']);
    const title = br.toUpperCase()[0] + br.substring(1);
    const other_browsers = useMemo(()=>{
        if (br == 'chrome')
            return ['opera', 'edge'];
        if (br == 'opera')
            return ['chrome', 'edge'];
        if (br == 'edge')
            return ['chrome', 'opera'];
    }, [br]);
    const [w, h] = use_element_size(is_client && {
        xs: [240, 200],
        md: [240, 200],
        all: [467, 387],
    });
    return <div className={theme.root}><div className={styles.top}>
      <div className={styles.text}>
      <h2>{hero_title}</h2>
      <p className={theme.u3}>{description}</p>
      <Button color={'black2023'} caption={`Add to ${title} - it's free`}
        on_click={()=>{
          open_store(false, br);
        }} size={'lg'}/></div>
      <div className={styles.man_img} key={screen}>
      <Lottie src={img_url(lottie_src)}
        width={w} height={h} autoplay
        cls={styles.man_lottie}/>
      </div></div>
      {with_options && <div className={styles.other_browsers_wrap}>
        <div className={styles.other_browsers}>
        <p className={cn(theme.p2, theme.med)}>Also available on</p>
        {other_browsers.map(b=>{
          return <button key={b}
            className={styles.browser_button} onClick={()=>{
              open_store(true, b); }}>
            {b=='opera' && <Fragment>
              <Svg_img id={'svg/pl/ic-opera-active.svg'} w={24} h={24}/><span
                className={cn(theme.P, theme.p2, theme.med)}>
                Opera Browser</span></Fragment>}
            {b=='edge' && <Fragment>
              <Svg_img id={'svg/pl/ic-edge-active.svg'} w={24} h={24}/><span
                className={cn(theme.P, theme.p2, theme.med)}>Microsoft
                edge</span></Fragment>}
            {b=='chrome' && <Fragment>
              <Svg_img id={'svg/pl/ic-opera-active.svg'} w={24} h={24}/><span
                className={cn(theme.P, theme.p2, theme.med)}>Chrome
                Browser</span></Fragment>}</button>; })}</div></div>}</div>;
};

export const Product_hero_editor = (props: i_product_hero_props_editor)=>{
  const {value = {title: '', description: '', type: '', lottie_src: '',
    with_options: ''}, on_change} = props;
  type editor_key = keyof i_product_hero;
  type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector';
  const editors = [
      ['title', 'Title', 'text'],
      ['description', 'Description', 'text'],
      ['lottie_src', 'Animation path', 'text'],
      ['type', 'Type(extension/mobile/desktop/tv/others)', 'text'],
      ['with_options', 'Enable store options', 'boolean'],
  ].map(([key, label, type])=>({key: key as editor_key, label,
      type: type as editor_type}));
  return <Editor
    value={value}
    editors={editors}
    on_change={on_change}
    title="Product_hero"
  />;
};
